import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormBuilder from '../../../../common/form-builder/FormBuilder';

export default function BoilerForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const lowSulpurConfirm = [
    {
      name: 'Yes',
    },
    {
      name: 'No',
    },
    {
      name: 'NA',
    },
  ];

  const boilerFormConfig = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'boilerNumber',
      label: t('labels.boilerNumber'),
      control: control,
      fieldType: 'number',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'lowSulphur',
      label: t('labels.lowSulphur'),
      control: control,
      fieldType: 'select',
      dataSource: lowSulpurConfirm,
      displayExpr: 'name',
      valueExpr: 'name',
    },
  ];

  return (
    <div className="row">
      <FormBuilder formConfig={boilerFormConfig} />
    </div>
  );
}
